/**
 * Which brand this page is being served under.
 *
 * americanworkerscomp.com is a publisher's dedicated workers comp site, served
 * from this same build by hostname — the way americancarcrash.com is served
 * from the autoaccidentteam app (see Brand.php there). It runs MLH's
 * /workers-comp-chat flow unchanged under its own skin, with its own landing
 * page. Each brand lists every hostname that serves it, so a local hostname
 * can be added here without hunting down the host comparison at every branch.
 *
 * Anything not on an AWC host is mylawsuithelp.com, and every helper here
 * answers with MLH's values there, so code that reads the brand behaves
 * exactly as it did before AWC existed.
 */

/** awc.org31415.local is the local development hostname, next to mlh.org31415.local. */
export const AWC_HOSTS = [
  'americanworkerscomp.com',
  'www.americanworkerscomp.com',
  'awc.org31415.local',
]

export const isAmericanWorkersComp = (hostname = window.location.hostname) =>
  AWC_HOSTS.includes(hostname)

export const AWC = {
  name: 'American Workers Comp',
  domain: 'americanworkerscomp.com',
  email: 'info@americanworkerscomp.com',
  // Sent with every AWC lead so it can be told apart from an MLH chat lead.
  publisher: 'americanworkerscomp',
  // MLH chat's Retreaver campaign. AWC's '/' needs it named explicitly, since
  // MLH's '/' has no number.
  retreaverCampaignKey: 'c2bb6db96b197da8a1521279b1812805',
  chatPath: '/workers-comp-chat',
}

/**
 * AWC's typeface, Archivo with its width axis (the wordmark and headlines use
 * the expanded width). Loaded at runtime, and only on AWC hosts, so MLH pages
 * never fetch it.
 */
export const loadAwcFont = () => {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = 'https://fonts.googleapis.com/css2?family=Archivo:wdth,wght@62..125,400..800&display=swap'
  document.head.appendChild(link)
}

/** The brand name legal copy is written under on the current host. */
export const brandName = () => isAmericanWorkersComp() ? AWC.name : 'My Lawsuit Help'

/** The address legal copy tells users to write to on the current host. */
export const brandEmail = () => isAmericanWorkersComp() ? AWC.email : 'info@mylawsuithelp.com'

/** Paths the AWC host serves. Everything else on that host redirects to '/'. */
export const AWC_PATHS = [
  '/',
  '/survey',
  '/workers-comp-chat',
  '/thank-you',
  '/privacy-policy',
  '/terms-of-use',
  '/partners',
  '/partners-mva',
  '/sponsors',
  '/do-not-sell-my-information',
]
